<template>
    <v-row class="d-flex justify-center login-form-wrapper h-100 align-content-center align-items-center">
        <v-col class="px-xl-0" cols="12" lg="10" xl="7">
            <v-card outlined class="login-screen">
                <v-card-text>
                    <div class="login-logo">
                        <img src="/images/logo/denzapine-logo-large.png" alt="denzapine-logo" />
                    </div>
                    <v-form ref="form">
                        <h3>{{ t('mfa::title') }}</h3>
                        <p>
                            {{ t('mfa::mfa_notice') }}
                        </p>
                        <p>
                            <strong>{{ t('mfa::note') }}</strong> {{ t('mfa::resend_notice') }}
                        </p>

                        <div class="d-flex justify-content-between">
                            <v-text-field
                                ref="codeRef"
                                v-model="code"
                                :label="t('mfa::code_placeholder')"
                                :placeholder="t('mfa::code_placeholder')"
                                outlined
                                required
                                rounded
                                :error-messages="errorMessages.code"
                                :rules="[
                                    (v) => !!v || t('default::validation.field.required'),
                                    (v) => (v && v.length === 6) || t('mfa::code_rules'),
                                ]"
                                class="medium"
                            ></v-text-field>
                            <v-btn
                                :loading="loadingVerify"
                                rounded
                                large
                                color="primary"
                                class="mt-5 ml-3"
                                @click="submit"
                            >
                                Continue
                            </v-btn>
                        </div>
                        <div class="d-flex justify-content-between px-3">
                            <div>
                                <a class="font-weight-bold text-primary" @click="resendCode">
                                    {{ t('mfa::resend_code') }}
                                </a>
                                <span v-if="resent && !sendingNewCode" class="ml-3 text-success">{{
                                    t('mfa::code_resent')
                                }}</span>
                                <v-progress-circular
                                    v-if="sendingNewCode"
                                    class="ml-10"
                                    size="20"
                                    color="primary"
                                    indeterminate
                                ></v-progress-circular>
                            </div>
                            <div>
                                <a @click="$root.goTo($root.route('auth.logout'))">{{ t('mfa::cancel') }}</a>
                            </div>
                        </div>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
export default {
    data: () => ({
        code: null,
        resent: false,
        resentError: null,
        sendingNewCode: false,
        loadingVerify: false,
        errorMessages: {
            code: null,
        },
    }),
    methods: {
        resendCode() {
            this.sendingNewCode = true;
            this.$refs.form.reset();
            this.resent = false;
            this.errorMessages.code = null;
            this.code = null;
            axios
                .post(route('mfa.resend-code'))
                .then(() => {
                    this.resent = true;
                })
                .catch((error) => {
                    this.resent = false;
                    this.resentError = error.response.data.message;
                })
                .finally(() => {
                    this.sendingNewCode = false;
                });
        },
        submit() {
            this.loadingVerify = true;
            this.resent = false;
            if (!this.$refs.form.validate()) {
                this.loadingVerify = false;
                return;
            }

            axios
                .post(route('mfa.verify'), {
                    code: this.code,
                })
                .then((response) => {
                    this.$root.goTo(response.data.redirect);
                })
                .catch((error) => {
                    _.each(error.response.data.errors, (fieldErrors) => {
                        this.errorMessages[fieldErrors.field] = fieldErrors.errors[0];
                    });
                })
                .finally(() => {
                    this.loadingVerify = false;
                });
        },
    },
};
</script>

<style scoped></style>
